import { useFormContext, Controller, FieldValues, Path } from 'react-hook-form';
import { Select } from '@radix-ui/themes';
import { SelectInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

export const SelectField = <TFormValues extends FieldValues>({
    config,
}: {
    config: SelectInputConfig<TFormValues>;
}) => {
    const { control } = useFormContext<TFormValues>();

    return (
        <FieldWrapper config={config}>
            <Controller
                name={config.name as Path<TFormValues>}
                control={control}
                rules={config.validation}
                render={({ field }) => (
                    <Select.Root
                        value={field.value || ''}
                        onValueChange={field.onChange}
                    >
                        <Select.Trigger placeholder={config.placeholder} />
                        <Select.Content
                            position='popper'
                            style={{ maxHeight: '250px' }}
                        >
                            {config.options.map((opt) => (
                                <Select.Item
                                    key={opt.value}
                                    value={String(opt.value)}
                                >
                                    {opt.label}
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Root>
                )}
            />
        </FieldWrapper>
    );
};
